export default __webpack_public_path__ + "static/pexels-pixabay-209954-71eac40a46728ea58defd35bfed24f55.jpg";